import type {Dimensions, Exemplar, PlacementAwareExemplar} from 'typings/portaro.be.types';
import type ExemplarPlacementDataService from './exemplar-placement.data-service';
import {ngAsync} from 'shared/utils/ng-@decorators';

const MAX_DIMENSION = 500;

export default class ExemplarPlacementService {
    public static readonly serviceName = 'exemplarPlacementService';

    /*@ngInject*/
    constructor(private exemplarPlacementDataService: ExemplarPlacementDataService) {
    }

    @ngAsync()
    public async loadPlacementIntoExemplar(exemplar: Exemplar): Promise<PlacementAwareExemplar> {
        const placementAwareExemplar = exemplar as PlacementAwareExemplar;

        if (placementAwareExemplar.placement) {
            return;
        }

        placementAwareExemplar.placement = await this.exemplarPlacementDataService.getExemplarPlacement(placementAwareExemplar.id);

        placementAwareExemplar.placement.dimensions = this.getDimensionsByMaxSide(placementAwareExemplar.placement.mapWidth, placementAwareExemplar.placement.mapHeight, MAX_DIMENSION);

        return placementAwareExemplar;
    }

    private getDimensionsByMaxSide(width: number, height: number, max: number): Dimensions {
        if (width > max || height > max) {
            const aspectRatio = width / height;

            if (width > height) {
                width = max;
                height = Math.round(width / aspectRatio);
            } else {
                height = max;
                width = Math.round(height * aspectRatio);
            }
        }
        return {
            width,
            height
        };
    }
}
